module.exports = __webpack_public_path__ + "img/170324.834b747f.png";